import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {environment} from "../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class SedesService {
  constructor(
    private http: HttpClient
  ) { }

  getHeaders(): HttpHeaders {
    return new HttpHeaders();
  }

  getSedes(): Observable<any> {
    const url = `${environment.endpointAdministrativo}/v1/obtenerSedes`
    return this.http.get<any>(url, { headers: this.getHeaders() })
  }
}
